function ajax(url, type, params, headers) {
    const xhr = new XMLHttpRequest();
    const requestType = type || 'GET';
    let requestUrl = url;

    if (requestType === 'GET' && params) {
        requestUrl = `${url}?${params}`;
    }
    xhr.open(requestType, requestUrl);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    if (requestType === 'POST') {
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }
    if (headers) {
        for (let i = 0; i < headers.length; i += 1) {
            const header = headers[i];

            xhr.setRequestHeader(header[0], header[1]);
        }
    }
    if (requestType === 'GET') {
        xhr.send();
    } else {
        xhr.send(params);
    }
    return xhr;
}

export default ajax;



// WEBPACK FOOTER //
// ./static_source/js/ajax.js